"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.preview.title': 'Avatar Preview',
    'avatar.preview.edit': 'Edit Avatar',
    'avatar.preview.back': 'Back to List',
    'avatar.preview.not_provided': 'Not provided',
    'avatar.preview.section.basic_info': 'Basic Information',
    'avatar.preview.section.logo': 'Avatar Logo',
    'avatar.preview.section.description': 'Description',
    'avatar.preview.section.ai_model': 'AI Model Configuration',
    'avatar.preview.section.knowledge': 'Knowledge Base',
    'avatar.preview.section.settings': 'Avatar Settings',
    'avatar.preview.section.validation': 'Configuration Status',
    'avatar.preview.logo.not_uploaded': 'No logo uploaded',
    'avatar.preview.provider': 'Provider',
    'avatar.preview.cost': 'Cost',
    'avatar.preview.model.not_selected': 'No AI model selected - This is required!',
    'avatar.preview.knowledge.entries_selected': 'knowledge entries selected',
    'avatar.preview.knowledge.none_selected': 'No knowledge base entries selected',
    'avatar.preview.validation.status': 'Configuration Validation',
    'avatar.preview.validation.complete': 'All required fields are completed',
    'avatar.preview.validation.incomplete': 'Some required fields are missing',
    'avatar.preview.no_data': 'No avatar data available',
    'avatar.preview.error.load_failed': 'Failed to load avatar for preview',
    'avatar.preview.voice.not_selected': 'No voice selected',
    'avatar.preview.unnamed': 'Unnamed Avatar',
    'avatar.preview.required': 'Required',
    'avatar.preview.gender.not_selected': 'No gender selected',
    'avatar.preview.section.conversations': 'Conversations',
    'avatar.preview.conversations.empty': 'No conversations with this avatar yet',
    'avatar.preview.conversations.untitled': 'Untitled conversation',
};
